<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <div>
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'Home' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to home</span>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text" v-if="loading.getdata">
              <v-col cols="12" md="12" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length > 0">
              <v-col cols="10" md="10">
                <div class="d-flex">
                  <div class="d-inline mr-5">
                    <v-img
                      :lazy-src="require('../../assets/default.jpg')"
                      max-height="70"
                      max-width="70"
                      :src="datalist[0].urlpic ? datalist[0].urlpic : ''">
                    </v-img>
                  </div>
                  <div class="d-inline">
                    <h2 class="text-md-h4 font-weight-bold">
                      {{ datalist[0].com_name }}
                    </h2>
                    <span class="text-subtitle-1">
                      {{ datalist[0].com_field ? datalist[0].com_field : 'Specialization'}}
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="2" md="2" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                <v-btn
                  class="mr-2 mb-2"
                  fab
                  depressed
                  color="error"
                  x-small
                  @click="updateProfile(datalist[0])">
                  <v-icon dark>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="12">
                <v-tabs
                  v-model="tabdata"
                  show-arrows>
                  <v-tabs-slider :color="maincolor"></v-tabs-slider>
                  <v-tab href="#profile" active-class="main-style-slide">
                    Profile
                  </v-tab>
                  <v-tab href="#pro-pic" active-class="main-style-slide">
                    Picture
                  </v-tab>
                  <v-tab href="#jobs" active-class="main-style-slide">
                    <v-badge
                      color="error"
                      :content="datalist[0].jumjob">
                      Jobs
                    </v-badge>
                  </v-tab>
                  <v-tab href="#mou" active-class="main-style-slide">
                    <v-icon
                      left
                      :color="maincolor"
                      class="mb-1">
                      mdi-handshake
                    </v-icon>
                    <v-badge
                      :color="datalist[0].com_mou === 'yes' ? 'success' : datalist[0].com_mou === 'review' ? 'info' : 'error'"
                      :icon="datalist[0].com_mou === 'yes' ? 'mdi-check' : 'mdi-information-variant'">
                      MoU
                    </v-badge>
                  </v-tab>
                </v-tabs>
                <v-divider></v-divider>
                <v-tabs-items :touchless="true" v-model="tabdata">
                  <v-tab-item value="profile">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Company size</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              <v-icon :color="maincolor">
                                mdi-account-group
                              </v-icon>
                              {{ datalist[0].com_size ? datalist[0].com_size : '2'}} employees
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Location</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              <v-icon :color="maincolor">
                                mdi-map-marker
                              </v-icon>
                              {{ datalist[0].com_location ? datalist[0].com_location : 'Location'}}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Est. Since</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              <v-icon :color="maincolor">
                                mdi-calendar-range
                              </v-icon>
                              {{ datalist[0].com_establish ? datalist[0].com_establish : '2020'}}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Address</span>
                            <p class="mb-3">
                              {{ datalist[0].com_address ? datalist[0].com_address : 'full address'}}
                            </p>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Contact</span>
                            <div class="mb-3">
                              <v-btn
                                :href="'tel:' + datalist[0].com_phone"
                                class="mr-2"
                                small
                                fab
                                outlined>
                                <v-icon>
                                  mdi-phone-classic
                                </v-icon>
                              </v-btn>
                              <v-btn
                                :href="'mailto:' + datalist[0].com_email"
                                class="mr-2"
                                small
                                fab
                                outlined>
                                <v-icon>
                                  mdi-email
                                </v-icon>
                              </v-btn>
                              <v-btn
                                :href="datalist[0].com_website"
                                target="_blank"
                                class="mr-2"
                                small
                                fab
                                outlined>
                                <v-icon>
                                  mdi-web
                                </v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12" v-show="!$vuetify.breakpoint.smAndDown">
                            <v-divider></v-divider>
                          </v-col>
                        </v-row>
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <h2 class="text-md-h5 font-weight-bold mb-3">
                              About {{ datalist[0].com_name ? datalist[0].com_name : 'Company name'}}
                            </h2>
                            <div
                              class="content-editor"
                              v-html="datalist[0].com_desc ? datalist[0].com_desc : 'Description'">
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pro-pic">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row justify="center" class="black--text">
                          <v-col cols="12" md="8">
                            <v-row class="text-center">
                              <v-col cols="12" md="5">
                                <div class="text-subtitle-1 mb-3">
                                  Current Picture
                                </div>
                                <v-img
                                  class="ma-auto"
                                  :lazy-src="require('../../assets/default.jpg')"
                                  max-height="150"
                                  max-width="150"
                                  aspect-ratio="1"
                                  :src="datalist[0].urlpic ? datalist[0].urlpic : ''">
                                </v-img>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-divider :vertical="!$vuetify.breakpoint.smAndDown"></v-divider>
                              </v-col>
                              <v-col cols="12" md="5">
                                <alertsp :alertdata="alertpic"></alertsp>
                                <div class="text-subtitle-1 mb-3">
                                  Update Picture
                                </div>
                                <div class="mb-3">
                                  <croppa v-model="myCroppa" :width="150" :height="150"></croppa>
                                </div>
                                <div>
                                  <v-btn
                                    :loading="loading.avatar"
                                    :disabled="loading.avatar"
                                    :color="maincolor"
                                    class="white--text"
                                    depressed
                                    small
                                    @click="uploadPicture">
                                    Update Picture
                                  </v-btn>
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="jobs">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col
                            class="d-flex" style="flex-direction:column"
                            cols="12"
                            md="4"
                            v-for="(job, i) in joblist"
                            :key="i">
                            <jobcompany :job="job"></jobcompany>
                          </v-col>
                        </v-row>
                        <v-row class="black--text text-center">
                          <v-col cols="12" md="12">
                            <infinite-loading :identifier="infiniteId" @infinite="getJobCom">
                              <div slot="spinner">Loading...</div>
                              <div slot="no-more"></div>
                              <div slot="no-results"></div>
                            </infinite-loading>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="mou">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row justify="center" class="black--text">
                          <v-col cols="12" md="4">
                            <div class="title font-weight-bold mb-3">
                              Become our partner
                            </div>
                            <div class="mb-3">
                              <div class="foot-list-icon float-left">
                                <v-icon :color="maincolor">
                                  mdi-checkbox-marked-outline
                                </v-icon>
                              </div>
                              <div class="foot-list-content">
                                Benefit 1 to be PNB Partner
                              </div>
                            </div>
                            <div class="mb-3">
                              <div class="foot-list-icon float-left">
                                <v-icon :color="maincolor">
                                  mdi-checkbox-marked-outline
                                </v-icon>
                              </div>
                              <div class="foot-list-content">
                                Benefit 2 to be PNB Partner
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-card flat>
                              <v-card-text class="pa-0 black--text">
                                <div class="title font-weight-bold mb-3">
                                  Memorandum of understanding (MoU)
                                </div>
                                <div v-if="datalist[0].com_mou === 'no'">
                                  <p>
                                    Perusahaan yang Anda <strong>{{ datalist[0].com_name }}</strong> belum memiliki kerjasama dengan <strong>Politeknik Negeri Bali</strong>, untuk mengajukan permohonan kerjasama mohon tekan tombol <strong>Make Request</strong> di bawah ini.
                                  </p>
                                  <v-btn
                                    small
                                    :color="maincolor"
                                    class="white--text"
                                    @click="requestMou(datalist[0])">
                                    Make Request
                                  </v-btn>
                                </div>
                                <div v-if="datalist[0].com_mou === 'review'">
                                  <p>
                                    Terimakasih telah melakukan permohonan kerjasama dengan Politeknik Negeri Bali.
                                    Permohonan yang dilakukan pada tanggal <b>{{ datalist[0].com_moureq }}</b> telah berhasil diajukan dan sedang di proses pihak Politeknik Negeri Bali.
                                    Proses mungkin memerlukan waktu <b>2 hari kerja</b>. Jika dibutuhkan pihak Politeknik Negeri Bali akan menghubungi perusahaan Anda.
                                    Terimakasih.
                                  </p>
                                  <p>
                                    Jika terjadi kendala, dapat menghubungi pihak kami melalui fitur
                                    <router-link class="text-decoration-none"
                                      :to="{ name: 'Contact' }">
                                      Contact
                                    </router-link>.
                                  </p>
                                </div>
                                <div v-if="datalist[0].com_mou === 'yes'">
                                  <div class="font-weight-bold">
                                    <v-icon class="mr-1 mb-1">mdi-update</v-icon>
                                    MoU between <b>{{ datalist[0].com_name }}</b> and <b>Politeknik Negeri Bali</b> valid until <b>{{ datalist[0].com_mouend }}</b>
                                  </div>
                                  <div class="mt-2">
                                    <iframe
                                      :src="getPdfView(datalist[0].urlmou)"
                                      style="width:100%; height:700px;"
                                      frameborder="0">
                                    </iframe>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length <= 0">
              <v-col cols="12" md="12">
                <v-alert type="warning">
                  Data not available, please try refreshing the data with the button below!
                </v-alert>
                <div class="text-center">
                  <v-btn
                    fab
                    depressed
                    color="primary"
                    @click="getProfile">
                    <v-icon dark large>
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.profile"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.profile">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Update company profile
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('profile')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="py-5">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdateProfile"
                    ref="formupdprofile"
                    v-model="formadd.company"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.com_name"
                              :rules="[rules.required]"
                              label="Company name *"
                              name="com_name">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.com_field"
                              :rules="[rules.required]"
                              label="Company field *"
                              name="com_field">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="dmodaldata.profile.com_size"
                              :rules="[rules.required]"
                              label="Company size *"
                              name="com_size">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="dmodaldata.profile.com_establish"
                              :rules="[rules.required]"
                              label="Company established *"
                              name="com_establish">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.com_location"
                              :rules="[rules.required]"
                              label="Company location *"
                              name="com_location">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.com_address"
                              :rules="[rules.required]"
                              label="Company address *"
                              name="com_address">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <label>Company description</label>
                            <vue-editor
                              class="mt-1"
                              v-model="dmodaldata.profile.com_desc"
                              placeholder="Company description"
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.com_phone"
                              :rules="[rules.required]"
                              label="Company phone *"
                              name="com_phone">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.com_email"
                              :rules="[rules.required, rules.email]"
                              label="Company email *"
                              name="com_email">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.com_website"
                              :rules="[rules.required]"
                              label="Company website *"
                              name="com_website">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.updcomp"
                          :disabled="loading.updcomp || !formadd.company"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Update profile
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog request mou -->
    <v-dialog
      v-model="dmodal.reqmou"
      max-width="500px"
      persistent>
      <v-card v-if="dmodaldata.reqmou">
        <v-alert
          icon="mdi-comment-question-outline"
          border="left"
          colored-border
          type="warning"
          class="mb-0">
          <p>
            Proses pebentukan kerjasama mungkin akan membutuhkan waktu <b>2 hari kerja</b>, jika dibutuhkan pihak Politeknik Negeri Bali akan menghubungi perusahaan Anda. Apakah anda setuju dengan ketentuan ini?
          </p>
          <alertsp :alertdata="alertupdate"></alertsp>
          <v-btn
            small
            depressed
            color="error"
            class="mr-2"
            @click="dmodal.reqmou = false">
            No
          </v-btn>
          <v-btn
            small
            depressed
            color="success"
            :loading="loading.reqmou"
            :disabled="loading.reqmou"
            @click="submitReqmou">
            Yes
          </v-btn>
        </v-alert>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';
import InfiniteLoading from 'vue-infinite-loading';
import Jobcompany from '../../components/Jobcompany.vue';
import { getGdriveView } from '@/plugins/utils';

export default {
  name: 'ProfileCompany',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertpic: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      updcomp: false,
      avatar: false,
      reqmou: false,
    },
    tabdata: 'profile',
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    paramjob: {
      com_id: '',
      valid: 'yes',
      limit: 20,
      offset: 0,
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    joblist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      company: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    dmodal: {
      profile: false,
      reqmou: false,
    },
    dmodaldata: {
      profile: null,
      reqmou: null,
    },
    myCroppa: {},
    infiniteId: +new Date(),
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getProfile();
    if (this.$route.query.tab && this.$route.query.tab !== '') {
      this.tabdata = this.$route.query.tab;
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getPdfView(url) {
      return getGdriveView(url);
    },
    requestMou(item) {
      this.dmodal.reqmou = true;
      this.dmodaldata.reqmou = JSON.parse(JSON.stringify(item));
      this.alertupdate.show = false;
    },
    submitReqmou() {
      this.alertupdate.show = false;
      if (this.tokenscr) {
        this.loading.reqmou = true;
        this.axios
          .put(
            this.api + '/api/company/mou',
            qs.stringify({}),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.alertupdate.show = false;
                this.dmodal.reqmou = false;
                this.dmodaldata.reqmou = null;
                this.getProfile();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.reqmou = false;
          })
          .catch((error) => {
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.reqmou = false;
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Invalid token!';
      }
    },
    uploadPicture() {
      const $thisvue = this;
      this.myCroppa.generateBlob((blob) => {
        $thisvue.alertupdate.show = false;
        if (blob) {
          $thisvue.loading.avatar = true;
          const formData = new FormData();
          // file image
          formData.append('filepic', blob, 'newpic.png');
          formData.append('oldpic', $thisvue.datalist[0].com_picture);
          $thisvue.axios
            .post(
              $thisvue.api + '/api/user/com-picture',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + $thisvue.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  $thisvue.datalist[0].urlpic = $thisvue.api + '/upload/avatar/' + resdata.data.name;
                  $thisvue.datalist[0].com_picture = resdata.data.name;
                  $thisvue.myCroppa.remove();
                } else {
                  $thisvue.alertupdate.show = true;
                  $thisvue.alertupdate.type = 'error';
                  $thisvue.alertupdate.text = resdata.message;
                }
              } else {
                $thisvue.alertupdate.show = true;
                $thisvue.alertupdate.type = 'error';
                $thisvue.alertupdate.text = 'Internal services error!';
              }
              $thisvue.loading.avatar = false;
            })
            .catch((error) => {
              console.log('Internal services error!');
              $thisvue.alertupdate.show = true;
              $thisvue.alertupdate.type = 'error';
              $thisvue.alertupdate.text = 'Internal services error!';
              $thisvue.loading.avatar = false;
            });
          // console.log(blob);
        } else {
          $thisvue.alertupdate.show = true;
          $thisvue.alertupdate.type = 'error';
          $thisvue.alertupdate.text = 'Please select the image!';
        }
      }, 'image/png', 0.8);
    },
    getProfile() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/user/profile',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datalist = resdata.data;
                if (resdata.data[0].com_picture) {
                  this.datalist[0].urlpic = this.api + '/upload/avatar/' + resdata.data[0].com_picture;
                  this.datalist[0].urlmou = this.api + '/upload/mou/' + resdata.data[0].com_moufile;
                } else {
                  this.datalist[0].urlpic = '';
                  this.datalist[0].urlmou = '';
                }
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getProfile();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'profile') {
        this.dmodal.profile = false;
      } else if (type === 'reqmou') {
        this.dmodal.reqmou = false;
      } else {
        this.dmodal.profile = false;
      }
    },
    updateProfile(item) {
      this.dmodal.profile = true;
      this.dmodaldata.profile = JSON.parse(JSON.stringify(item));
    },
    submitUpdateProfile() {
      // console.log(this.dmodaldata.profile);
      this.alertupdate.show = false;
      if (this.$refs.formupdprofile.validate()) {
        if (this.tokenscr) {
          this.loading.updcomp = true;
          this.axios
            .put(
              this.api + '/api/user/com-profile',
              qs.stringify(
                this.dmodaldata.profile,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = this.dmodaldata.profile.com_name + '" has been changed successfully!';
                  this.getProfile();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updcomp = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.updcomp = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    getJobCom($state) {
      if (this.tokenscr && this.datalist.length > 0) {
        this.paramjob.com_id = this.datalist[0].com_id;
        this.axios
          .get(
            this.api + '/api/jobs/',
            {
              params: this.paramjob,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramjob.offset += this.paramjob.limit;
                  resdata.data.forEach((element) => {
                    this.joblist.push(element);
                  });
                  // this.joblist.push(...resdata.data);
                  if (this.joblist.length < this.paramjob.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
    InfiniteLoading,
    Jobcompany,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
